import {UNEXPECTED_SERVER_RESPONSE} from "$lib/constants";
import getFormFileds from "$lib/helpers/getFormFields";
import apiHelper from "$lib/services/helper";

/**
 в данном файлике реализуем апи работы с Новостями
 */
export const FeedbackApi = (userToken?: string) => {
  const API_NAME = "feedback-forms";

  const { postFormData } = apiHelper(userToken);

  return {
    postFeedback: async (params: any = {}) => {
      const formData = new FormData();

      const { file, ...otherParams } = params;

      formData.append("data", JSON.stringify(otherParams));

      if (file?.size > 0) {
        formData.append('files.files', file);
      }

      // if (files?.length) {
      //   files.map((file) => {
      //     if (file.size > 0) {
      //       formData.append('files.files', file);
      //     }
      //   })
      // }

      const { err, data } = await postFormData(API_NAME, formData);

      if (err) {
        return { err }
      }

      if (!data || !data?.data) {
        return { err: UNEXPECTED_SERVER_RESPONSE }
      }

      return {
        err,
        data: data?.data
      }
    }
  }
}
